import { useRouter } from 'next/router'
import { useEffect } from 'react'
import routesConfig from '@mindfulchefuk/config/routesConfig'
import { useIsNewCustomer } from './useIsNewCustomer'

export const useChooseRecipesRedirect = () => {
  const router = useRouter()
  const { isCustomer, isFetched, isNewCustomer } = useIsNewCustomer()

  useEffect(() => {
    if (!isCustomer) return

    if (isFetched && !isNewCustomer) {
      router.replace(routesConfig.upcoming.pathname)
    }
  }, [router, isCustomer, isFetched, isNewCustomer])

  return {
    showLoader: isCustomer && !isFetched,
  }
}
